import {Component, Input} from '@angular/core';

@Component({
  selector: 'registered-message',
  template: `
    <div *ngIf="registered">
      <h3 class="text-center" style="padding-top:20px;">You have successfully registered for an account.</h3>
      <div class="text-center">A member of our team will be in touch with you.</div>
      <div class="text-center"><a routerLink="/login">Return to login page</a></div>
    </div>
  `,
  styles: []
})
export class RegisteredMessageComponent {
  @Input() registered: boolean;
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/registered-message.ts